import React, { Fragment } from 'react';
import './index.scss';

/*
 * The classic "masonry" style Pinterest grid
 * @prop {number} columns - the number of columns in the grid
 * @prop {number} columnWidth - the fixed width of the columns
 * @prop {number} gutter  - the number of columns in the grid
 * @prop {Array}  items   - the list of items to render
 */
function formatZ(s) {
	return ('0' + s).slice(-2);
}
export default class ImageLayout extends React.Component {
	constructor(props) {
		super(props);
		this.columnHeights = Array.from({ length: props.columns }, () => 0);
		// console.log('init', this.columnHeights);
		this.renderItem = this.renderItem.bind(this);
		this.renderDescItem = this.renderDescItem.bind(this);
	}
	/*
	 * Get the shortest column in the list of columns heights
	 */
	getShortestColumn() {
		const minValue = Math.min(...this.columnHeights);
		// console.log ( "this.columnHeights..." , this.columnHeights);
		return this.columnHeights.indexOf(minValue);
	}
	getMaxHeight() {
		const maxValue = Math.max(...this.columnHeights);
		// console.log('maxValue', maxValue);
		return maxValue;
	}
	shouldComponentUpdate(nextProps, nextState) {
		// console.log('!nextProps', nextProps.update);
		// if (!nextProps.refreshCharts) {
		//     return false;
		// }
		return nextProps.update ? true : false;
	}
	/*
	 * Determine the top and left positions of the grid item. Update the
	 * cached column height.
	 * @param {Object} item - the grid item
	 * @param {Object} item.height - the grid item's image height
	 * @param {Object} item.width - the grid item's image width
	 */
	getItemStyle(item, index) {
		const { columnWidth, gutter, columns } = this.props;
		let { descHeight = 0, width, height } = item;
		let prizeHeight = 0;
		console.log ("descHeight" , descHeight , width, height);
		// descHeight = 0;
		width = width || 1;
		height = height || 1;
		if (item.prizeName) {
			prizeHeight = (24 * 2) / 75;
		}
		width = (width * 2) / 75;
		height = (height * 2) / 75;
		let shortestColumnIndex = this.getShortestColumn();
		if (index === 0) {
			this.columnHeights = Array.from({ length: columns }, () => 0);
			shortestColumnIndex = 0;
		}
		// let isOdd = !(index % 2);
		const left = (columnWidth + gutter) * shortestColumnIndex;
		// const left = isOdd ? (columnWidth + gutter) * shortestColumnIndex + 'px' : 'auto';
		// const right = isOdd ? 'auto' : '0';
		// console.log(this.columnHeights);
		// console.log(shortestColumnIndex);
		const top = this.columnHeights[shortestColumnIndex];
		const normalizedHeight = (columnWidth / width) * height + descHeight + prizeHeight;
		this.columnHeights[shortestColumnIndex] += normalizedHeight + gutter;
		console.log ("heightheight" , width ,height);
		let boxHeight = (columnWidth * height) / width + descHeight + prizeHeight;
		// console.log('......', top, this.columnHeights, index);
		return {
			left: `${left}rem`,
			top: `${top}rem`,
			width: `${columnWidth}rem`,
			height: `${boxHeight}rem`,
			position: `absolute`,
			overflow: 'hidden',
			borderRadius: '4px'
		};
	}
	// 搜索结果页面
	searchFooter(item, index, likeStatus, endorseCount) {
		let { onDownload = () => {}, onPraise = () => {} } = this.props;
		return (
			<div className="opration">
				<span
					className={'praise ' + (likeStatus === 1 ? 'yes' : 'no')}
					onClick={() => {
						onPraise(item, index);
					}}>
					<i>&#xe668;</i>
					{endorseCount}
				</span>
				<span
					className="share"
					onClick={() => {
						onDownload(item, index);
					}}>
					<i>&#xe656;</i>下载
				</span>
			</div>
		);
	}
	/*
	 * Render helper for an individual grid item
	 * @param {Object} item - the grid item to render
	 * @param {Object} item.url - the image src url
	 */
	renderItem(item, index) {
		return <img alt="" className="ImageLayout__item lazy" data-src={item.url} width={this.props.columnWidth} style={this.getItemStyle(item, index)} key={index} />;
	}
	renderDescItem(item, index) {
		let { onClick = () => {}, columnWidth, onMore = () => {}, onShare = () => {}, onPraise = () => {} } = this.props;
		let { smallUrl, prizeName, duration, description, sectionDescription, date, width, height, descHeight = 0, type, avatar, nickname, endorseCount, likeStatus, mutil } = item;
		let url = smallUrl;
		width = width || 1;
		height = height || 1;
		//item["height"] = height + descHeight;
		console.log(item.descHeight, item.descHeight > 90 / 75);
		if (!sectionDescription && item.descHeight > 90 / 75) {
			item.descHeight = item.descHeight - (45 * 2) / 75;
			console.log('into desc height');
		}
		console.log('ddddd....', item.descHeight);
		console.log(height, width);

		let boxHeight = (columnWidth * height) / width;
		return (
			<div style={this.getItemStyle(item, index)} key={index}>
				{type === 2 ? (
					<div
						className="video-wrap"
						onClick={() => {
							onClick(item, index);
						}}
						style={{ width: columnWidth + 'rem', height: boxHeight + 'rem' }}>
						<div className="bgvideo"></div>
						<i className="play">
							&#xe66a;
							<br />
							<span className="time">{duration ? formatZ(parseInt(duration / 60, 10)) + ':' + formatZ(duration % 60) : ''}</span>
						</i>
					</div>
				) : (
					''
				)}
				{mutil ? (
					<div
						className="gallery-bg"
						onClick={() => {
							onClick(item, index);
						}}>
						<i className="mutil-icon">&#xe663;</i>
					</div>
				) : (
					''
				)}
				<img
					alt=""
					onClick={() => {
						onClick(item, index);
					}}
					className="lazy"
					data-src={url}
					style={{ float: 'left', width: columnWidth + 'rem', height: boxHeight + 'rem' }}
				/>
				<div className="falls-desc">
					{prizeName ? (
						<div className="prize" style={{color: '#f3a950'}}>
							<i>&#xe672;</i>
							<div className="prize-name">{prizeName}</div>
						</div>
					) : (
						''
					)}
					{sectionDescription ? (
						<div className="title-wrap">
							<div className="title">{sectionDescription || ''}</div>
						</div>
					) : (
						''
					)}
					<div className="user">
						<img className="lazy" data-src={avatar || 'https://gallerytemplate.vphotos.cn/copyright/default-avatar.jpg'} width="22.5" height="22.5" alt="" />
						<span className="name">{nickname || 'www'}</span>
						{type === 2 ? (
							<i
								className="more"
								onClick={() => {
									onMore(item, index);
								}}>
								&#xe666;
							</i>
						) : (
							''
						)}
					</div>
					{!this.props.isSearch ? (
						<div className="opration">
							<span
								className={'praise ' + (likeStatus === 1 ? 'yes' : 'no')}
								onClick={() => {
									onPraise(item, index);
								}}>
								<i>&#xe668;</i>
								{endorseCount}
							</span>
							<span
								className="share"
								onClick={() => {
									onShare(item, index);
								}}>
								<i>&#xe657;</i>分享
							</span>
						</div>
					) : (
						this.searchFooter(item, index, likeStatus, endorseCount)
					)}
				</div>
			</div>
		);
	}
	render() {
		const { items, isDesc } = this.props;
		let imgArray = [];
		console.log('falls....', items);
		imgArray = isDesc ? items.map(this.renderDescItem) : items.map(this.renderItem);
		// console.log('imgArray', imgArray);
		return (
			<div className="ImageLayout falls-wrap" style={{ position: 'relative', height: this.getMaxHeight() + 'rem' }}>
				{imgArray}
				{/* <div>{
                    this.props.children
                }</div> */}
			</div>
		);
	}
}

// ImageLayout.propTypes = {
//     // The number of columns in the grid
//     columns: React.PropTypes.number,
//     // The fixed width of the columns in the grid
//     columnWidth: React.PropTypes.number,
//     // The size of the gutter between images
//     gutter: React.PropTypes.number,
//     // The list of images to render
//     items: React.PropTypes.arrayOf(
//         React.PropTypes.shape({
//             height: React.PropTypes.number.isRequired,
//             url: React.PropTypes.string.isRequired,
//             width: React.PropTypes.number.isRequired
//         })
//     ).isRequired
// };

ImageLayout.defaultProps = {
	columns: 4,
	columnWidth: 100,
	gutter: 0
};
